import { Controller } from "@hotwired/stimulus"

// Keeps a submit button disabled until its acceptance checkbox is ticked
// ("J'ai lu et j'accepte les conditions…").
export default class extends Controller {
  static targets = ["checkbox", "submit"]

  connect () {
    this.toggle()
  }

  toggle () {
    this.submitTarget.disabled = this.checkboxTarget.disabled || !this.checkboxTarget.checked
  }
}
